import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';

@Injectable({ providedIn: 'root' })
export class RpaSystemApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/rpa-system`;
  }

  async sendProcessStopRequest(processId: string): Promise<void> {
    return await this.post(`processes/${processId}/request-stop`, null);
  }

  async sendSessionStopRequest(sessionId: string): Promise<void> {
    return await this.post(`sessions/${sessionId}/request-stop`, null);
  }

  async restartResource(resourceId: string): Promise<void> {
    return await this.post(`resources/${resourceId}/restart`, null);
  }
}
